import { css, keyframes } from "emotion";
import FocusTrap from "focus-trap-react";
import { Component } from "preact";
const closeIcon = require("../assets/images/ic_close.svg");

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasOpened: false
    };
  }

  componentDidUpdate() {
    const { showModal } = this.props;
    if (showModal) {
      if (!this.state.hasOpened) {
        this.setState({ hasOpened: true });
      }
      this.addKeyDownListener();
      return;
    }
    this.removeKeyDownListener();
  }

  componentDidMount() {}

  componentWillUnmount() {
    this.removeKeyDownListener();
  }

  checkDocumentKeyDown = event => {
    const { closeHandler } = this.props;
    if (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27) {
      closeHandler(event);
    }
  };

  addKeyDownListener() {
    document.addEventListener("keydown", this.checkDocumentKeyDown);
  }

  removeKeyDownListener() {
    document.removeEventListener("keydown", this.checkDocumentKeyDown);
  }
  render({
    showModal,
    closeHandler,
    title,
    contents,
    footer,
    children,
    padding = 20,
    destroy = true,
    includeCloseButton = true
  }) {
    const hasOpened = this.state.hasOpened;
    const fadeIn = keyframes({
      from: {
        opacity: 0.5
      },
      to: {
        opacity: 1
      }
    });
    const grow = keyframes({
      from: {
        transform: `scale(0.9)`
      },
      to: {
        transform: `scale(1)`
      }
    });
    /* The Modal (background) */
    const modal = css({
      display: showModal ? "flex" : "none",
      justifyContent: "center",
      alignItems: "flex-start",
      position: "fixed",
      zIndex: 100001,
      paddingTop: 80,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      background: "transparent",
      "@media(max-width: 600px)": {
        paddingTop: "20vh"
      }
    });

    const modalBackground = css({
      backgroundColor: "rgba(0,0,0,0.6)",
      animation: `${fadeIn} 0.3s ease-in-out`,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      overflow: "auto",
      position: "absolute"
    });

    /* Modal Content */
    const modalContent = css({
      position: "relative",
      backgroundColor: "#fefefe",
      padding: padding,
      border: "1px solid #888",
      borderRadius: 4,
      display: "inline-block",
      animation: `${grow} 0.2s ease-in-out`,
      overflow: "scroll",
      minWidth: 300,
      maxWidth: "calc(100vw - 28px)",
      maxHeight: "calc(100vh - 80px)",
      "@media(max-width: 600px)": {
        maxHeight: "100vh",
        paddingBottom: 80,
        minWidth: 200,
        width: "100%",
        borderRadius: 0
      }
    });

    /* The Close Button */
    const close = css({
      border: "none",
      position: "absolute",
      background: "#fff",
      right: 20,
      top: 20,
      width: 24,
      height: 24,
      backgroundImage: `url(${closeIcon})`,
      zIndex: 10
    });

    const footerStyle = css({
      borderTop: "1px solid #D8D8D8",
      padding: "12px 0 6px",
      margin: "0 0 6px 0",
      display: "flex"
    });

    return (
      <div className={modal}>
        <div className={modalBackground} />
        {showModal || (!destroy && hasOpened) ? (
          <FocusTrap>
            <div
              className={modalContent}
              aria-modal="true"
              role="dialog"
              id="modal-wrapper"
            >
              {includeCloseButton ? (
                <button
                  type="button"
                  className={close}
                  onClick={closeHandler}
                  aria-label="Close"
                  data-cy="close"
                />
              ) : null}
              <h3>{title}</h3>
              {contents ? <div>{contents}</div> : children}
              {footer ? <div className={footerStyle}>{footer}</div> : null}
            </div>
          </FocusTrap>
        ) : null}
      </div>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./components/Modal.js